import styled from 'styled-components';
import * as palette from '../../../styles/variables';


export const Actions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const TableSection = styled.div`
  width: 100%;
  text-align: left;
  margin: 0;
  position: relative;
  a {
    position: absolute;
    top: -30px;
    right: 0;
    font-size: 12px;
    letter-spacing: 0.5px;
    color: #fff;
    font-weight: 700;
  }
  .block {
    display: flex;
    flex-direction: column;
    flex-direction: column;
    justify-content: space-between;
    width: ${props => props.nested ? 'inherit' : '475px'};
    padding: 20px;
    min-height: 50px;
    /* background: rgb(58 60 62);
    border: 2px solid rgb(88 86 86); */
    border-radius: 10px;
    row-gap: 25px;
    /* margin-bottom: 25px; */
    .varName {
      display: flex;
      align-items: center;
      align-items: center;
      height: 20%;
      margin-top: 10px;
      /* width: 55%; */
      p {
        font-size: 11px;
        line-height: 1.5;
        color: #14b0b6;
      }
    }

    &.block {
      width: inherit !important;
    }
  }
  .ant-empty {
    margin: 60px !important;
    color: #fff !important;
  }

  .ant-collapse-borderless {
    background-color: transparent !important;
  }
  .ant-collapse-item.ant-collapse-item-active {
    background: rgb(58 60 62) !important;
    margin-bottom: 10px !important;
  }
  .ant-collapse-item {
    background: rgb(58 60 62) !important;
    margin-bottom: 10px !important;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    color: #fff !important;
    font-size: 12px;
    letter-spacing: 1.5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow {
    left: 15px !important;
  }
  .ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding-left: 35px !important;
  }
  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0 !important;
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  .ant-table-wrapper {
    overflow-x: auto;
    table {
      border-radius: 4px;
      tbody {
        tr {
          td {
            :first-child {
              width: 40px;
              > div {
                display: flex;
                justify-content: center;
              }
            }
            padding: 0px !important;
            background: rgb(37, 41, 45) !important;
            color: #f5f5f5 !important;
            .ant-input {
              color: rgba(245, 245, 245, 0.85) !important;
              height: 40px;
            }
            .checkbox-wrapper {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
          :last-child > td {
            :first-child {
              border-bottom-left-radius: 4px;
            }
            :last-child {
              border-bottom-right-radius: 4px;
            }
          }
        }
      }
      thead {
        tr {
          th {
            background: rgb(37, 41, 45);
            color: #f5f5f5;
            font-weight: bold;
          }
        }
      }
    }
  }
  > button {
    padding-left: 0px;
    > span,
    .anticon {
      font-size: 12px;
      line-height: 1.5;
      color: #75faff;
      font-weight: 600;
      letter-spacing: 1px;
    }
  }
`;

export const ColumnHeaderErrorIcon = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  .anticon-exclamation-circle {
    color: #ff0000;
  }
`;

export const ListGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 20px;
  width: 90%;
  // cursor: ${({isInteractiveDesign}) => isInteractiveDesign && 'not-allowed'};
  // * {
  //   pointer-events: ${({isInteractiveDesign}) => isInteractiveDesign && 'none'};
  // }

  .warning-text {
    color: #ff0000;
  }
  .ant-input {
    background: transparent !important;
    color: #d9d9d9 !important;
    width: 100%;
    height: 35px;
  }
  .variable-type {
    color: rgb(255, 255, 255);
    font-size: 11px;
    background: rgb(177, 39, 44);
    border-radius: 30px;
    height: 22px;
    width: 22px;
    text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .sample {
    font-size: 11px !important;
    margin: 10px 0 20px 0;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #9b9b9b;
  }
  .ant-calendar-picker {
    width: 100%;
  }
  .ant-calendar-picker-icon {
    color: #fff;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  padding: 15px;
`;

export const RowSection = styled.div`
  margin-top: ${props => props.marginTop && '20px'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${props => props.isPreview && 'space-between'};
  .swith-btn{
    color:white;
    display: flex;
    align-items: center;
  }
  .ant-btn,
  .ant-btn:hover,
  .ant-btn:focus,
  .ant-btn:active {
    outline: 0;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    border-radius: 50px;
    background-color: ${props => props.releaseBtn ? '#6969d8' : '#ffeb3b'} ;
    border: #ffeb3b;
    color: ${props => props.releaseBtn ? 'white' : '#000'};
    min-width: 150px;
  }
  .ant-btn .anticon {
    font-size: 13px;
  }
  .ant-btn.preview {
    display: flex;
    align-items: center;
    justify-content: center;
    .anticon {
      margin-right: 10px !important;
    }
    p {
      font-size: 10px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: #000;
    }
  }
  .error-message{
    color: #ff0000;
  }
  ${props => props.downloadPayload && `
    justify-content: flex-end;
    .ant-btn, .ant-btn:hover, .ant-btn:focus {
      background: transparent;
      color: #FF9D00;
    }
  `}
`;

export const ListContainer = styled.div`
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  overflow-y: auto;
  height: 80%;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const VariableDataContainer = styled.div`
  display: ${props => !props.isObject && 'flex'};
  flex-wrap: ${props => !props.isObject && 'wrap'};
  justify-content: ${props => !props.isObject ? props.isHtml?'flex-start':'space-between':''};
`;

export const VariableDetail = styled.div`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
  width: ${props => (props.isBlock ? '100%' :props.isHtmlBlockExpanded &&  (props?.expandedVariablesList?.includes(props.uniqid)) ? '75%' : props.isVarName ? '' : '60%')};
  margin-top: ${props => props.isList && '20px !important'};
  align-items: ${props=> props.isHtml?'flex-start':'center'};
  p {
    font-size: 12px;
    line-height: 1.5;
    color: #75faff;
    text-transform: uppercase;
    margin-right: 15px;
    font-weight: 600;
    letter-spacing: 1px;
  }
  .ant-switch {
    height: 22px !important;
    width: 60px !important;
  }
`;

export const ModalTagContainer = styled.div`
  display: flex;
  align-items: center;
  border: ${props => (props.border ? '1px solid #000' : '1px solid #b9b9b9')};
  border-radius: 8px;
  padding: 10px 10px 0px 10px;
  flex-wrap: wrap;
  overflow: ${props => props.tagSearch && 'hidden'};
  overflow-y: ${props => props.tagSearch && 'auto'};
  background: ${props => props.tagSearch && '#fff'};
  width: 100%;
  .ant-tag {
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 4px 7px;
    margin: 0px 10px 10px 0px;
    background: ${props =>
      props.tagSearch && 'linear-gradient(to right,#6B8DD6,#8E37D7) !important'};
  }
  .ant-tag .anticon-close {
    font-size: 14px !important;
    font-weight: 600 !important;
    color: ${props => (props.tagSearch ? '#000 !important' : '#df4c35 !important')};
    background: #fff !important;
    padding: 2px !important;
    border-radius: 25px !important;
    margin-left: 10px !important;
  }
  .ant-input {
    border: none !important;
    outline: none !important;
    margin-bottom: 10px !important;
    color: #171717 !important;
    ::placeholder {
      color: #767676 !important;
    }
    &.ant-input:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const OverrideTabContainer = styled.div`
  height: calc(100vh - 130px);
  overflow: hidden;
  overflow-y: auto;
  color: white;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  cursor: ${({editable}) => !editable && 'not-allowed'};
  cursor: ${({isInteractiveDesign}) => isInteractiveDesign && 'not-allowed'};
  padding: 0px 20px 0px 23px;
  ::-webkit-scrollbar {
    display: none;
  }
  .variable-type {
    color: rgb(255, 255, 255);
    font-size: 11px;
    background: rgb(225, 7, 48);
    border-radius: 50%;
    height: 8px;
    width: 8px;
    text-align: center;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .yellow-bg {
    background-color: ${palette.APP_BRAND_YELLOW_COLOR};
  }
  a {
    font-size: 14px;
    letter-spacing: 0.5px;
    color: #fff;
    font-weight: 700;
    margin-right: 4px;
  }
  .reset-link {
    margin-top: 4px;
    flex: none;
    align-self: flex-start;
  }
  > .reset-all {
    align-self: end;
    color: #ff0000;
    margin-right: 2px;
    pointer-events: ${({editable}) => !editable && 'none'};
    pointer-events: ${({isInteractiveDesign}) => isInteractiveDesign && 'none'};
  }
`;

export const OverrideContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  pointer-events: ${({editable}) => !editable && 'none'};
  pointer-events: ${({isInteractiveDesign}) => isInteractiveDesign && 'none'};

  .object-container {
    color: ${palette.APP_BRAND_YELLOW_COLOR};
    font-size: 16px;
    font-weight: bold;
  }

  .name-container {
    display: flex;
    column-gap: 10px;
    align-items: baseline;
    margin-left: ${props => props.isObject && '15px'};

    .variable-name {
      color: #75faff;
      font-weight: bold;
    }
  }
  .override-container {
    display: flex;
    flex-direction: row;
    column-gap: 10;
    justify-content: space-between;
    align-items: center;
    margin-left: ${props => props.isObject && '15px'};

    .required-container {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      column-gap: 10px;
      row-gap:10px;

      .required-label {
        display: flex;
        flex-direction: row;
        column-gap: 10px;
        align-items: center;
      }
    }

    .max-character-container {
      display: flex;
      flex-direction: row;
      column-gap: 10;
      align-items: center;
    }
  }
`;
export const RichTextEditorContainer = styled.div`
  color: white !important;
  font-weight: normal !important;
  width:100% !important;
  transition: width 0.6s ease;

  button .ql-stroke,
.ql-picker-label .ql-stroke {
  fill: none;
  stroke: white !important;
}


  button:hover .ql-stroke,
.ql-picker-label:hover .ql-stroke {
  fill: none;
  stroke: ${props => props.isTemplateDescription ? '#FFEB3B' : 'blue'} !important;
}

.ql-active .ql-stroke {
  fill: none;
  stroke: ${props => props.isTemplateDescription ? '#FFEB3B' : 'blue'} !important;
}

button:hover .ql-fill,
.ql-picker-label:hover .ql-fill {
  fill:  ${props => props.isTemplateDescription ? '#FFEB3B' : 'blue'} !important;
  stroke: none;
}

.ql-active .ql-fill {
  fill: blue !important;
  stroke: none;
}
  width:${props => props.isExpanded && (props?.expandedVariablesList?.includes(props.uniqid)) ? '100%' : '100%'} !important;

  .ql-toolbar.ql-snow .ql-formats {
      margin-right: 4px !important;
  }
  .custom-picker.ql-expanded .ql-picker-options{
      display: none !important;
  }
  .ql-icon-picker.ql-expanded .ql-picker-options{
    display: flex !important;
    border-radius: 5px
    transition: 0.8s ease
  }
   &.ql-active {
        color: white;
        background: #454545;
        border-radius: 4px;
        .ql-fill {
          fill: white;
        }
        .ql-stroke {
          stroke: #fff;
        }
  }

  p {
    font-size:  ${props => props.isTemplateDescription ? '16px':'12px'};
    line-height: 1.5;
    color: white;
    color:  ${props => props.isTemplateDescription ? 'black':'white'};
    text-transform: none;
    margin-right: 15px;
    font-weight: normal;
    letter-spacing: 1px;
  }

  .ql-container.ql-snow{ 
    transition:${props => props.isExpanded ? 'height 0.6s ease' : 'height 0.2s ease'}  !important; 
    color: white !important;
    height: ${props => props.isTemplateDescription ? '200px' : props.isExpanded && (props?.expandedVariablesList?.includes(props.uniqid)) ? '300px' : '100px'} !important;
        overflow: hidden !important;
        overflow-y: auto !important; 
    ::-webkit-scrollbar {
    width: 0px; 
    }
    ::-webkit-scrollbar-thumb {
    background-color: transparent !important;
    }
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .ql-editor{
      transition:${props => props.isExpanded ? 'height 0.6s ease' : 'height 0.2s ease'}  !important; 
      overflow: hidden !important;
      overflow-y: auto !important; 
      ::-webkit-scrollbar {
          width: 0px; 
        }
        ::-webkit-scrollbar-thumb {
           background-color: transparent !important;
        }
    }

  .ql-custom{
      background-color: white !important;
  }

  .ql-toolbar.ql-snow {
      background: ${props => props.isTemplateDescription && 'darkslategrey'};
      border: 1px solid #ccc;
      border-radius: ${props => props.isTemplateDescription? '9px' : '5px'};
      box-sizing: border-box;
      font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
      padding: 8px;
  }
  .ql-snow .ql-stroke {
      stroke: grey ;
      :hover {
          .ql-stroke {
            stroke: grey !important;
          }
  }
   
`;

export const StyledAccessibilityPreview = styled.div`
  position: absolute;
  top: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  .container {
    padding: 2px;
    width: 600px;
    height: 80%;
    border-radius: 24px;
    background: #FEAC5E;
    background: -webkit-linear-gradient(to right, #4BC0C8, #C779D0, #FEAC5E);
    background: linear-gradient(to right, #4BC0C8, #C779D0, #FEAC5E);
    overflow: hidden;
  }
  .hide-background {
    background: none;
  }
  .script {
    padding: 18px;
    height: 100%;
    background: #fff;
    color: #000;
    font-family: Lato, sans-serif;
    font-size: 18px;
    font-style: italic;
    border-radius: 24px;
    overflow-y: auto;
    direction: ${props => props.isRTLLanguage ? 'rtl' : 'initial'};
  }
  .script-word:hover {
      color: #FEAC5E;
      cursor: pointer;
  }
  .current-word {
    background: #C779D0;
    color: #fff;
  }
  .controls {
    padding-block: 12px;
    width: 300px;
    background: #000;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    position: relative;
  }
  .control-key {
    width: 80px;
    display: grid;
    place-items: center;
  }
  button {
    outline: none;
    border: none;
    background: transparent;
    color: #fff;
    cursor: pointer;
  }
  .label {
    display: block;
    color: #fff;
    font-size: 12px;
    font-family: Lato, sans-serif;
  }
  button[disabled], .disabled-text {
      opacity: 0.5;
      cursor: default;
  }
  .play-button {
    height: 50px;
    width: 50px;
    background: #4BC0C8;
    border-radius: 50%;
    position: relative;
    z-index: 1;
  }
  .playing::before, .playing::after {
    content: '';
    width: 60px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #4BC0C8;
    border-radius: 50%;
    z-index: -1;
    animation: wave 2s ease infinite;
  }
  .playing::after {
    animation-delay: 0.5s;
  }
  @keyframes wave {
    100% {
      transform: translate(-50%, -50%) scale(180%);
      opacity: 0;
    }
  }
  .speed-control {
    display: flex;
    align-items: center;
  }
  .speed-control p {
    width: 28px;
    text-align: center;
    font-family: 'Lato', sans-serif;
  }
  .voice-list {
    position: absolute;
    top: -24px;
    height: 24px;
    width: 250px;
    background: #333;
    font-family: 'Lato', sans-serif;
    border-radius: 25px 25px 0 0;
    overflow: hidden;
    transition: all 0.2s linear;
  }
  .voice-list div {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .voice-list-visible {
    top: -150px;
    height: 150px;
  }
  .voice-list ul {
    height: 124px;
    margin-inline: 3px;
    list-style: none;
    background: #000;
    border-radius: 12px 12px 0 0;
    overflow-y: auto;
  }
  .voice-list ul li {
    padding: 4px;
    font-size: 12px;
  }
  .voice-list ul li:hover, .selected {
    background: #C779D0;
    cursor: pointer;
  }
  .empty {
    height: 100%;
    width: 80%;
    margin: auto;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 18px;
  }
  .empty img {
    width: 200px;
  }

  .scroll-container::-webkit-scrollbar {
    width: 4px;
  }
  .scroll-container::-webkit-scrollbar-track {
    background: transparent;
  }
  .scroll-container::-webkit-scrollbar-thumb {
    background-color: #999;
    border-radius: 4px;
  }
  .scroll-container::-webkit-scrollbar-button {
    height: 0;
    display: none;
  }
  .ant-alert {
    position: absolute;
    top: 8px;
    max-width: 450px;
  }
  .ant-alert-error {
    background-color: #ffd7d7;
    border: 1px solid #ff0000;
  }
  .ant-alert-with-description {
    color: #ff0000;
    font-family: Lato, sans-serif;
  }
  .ant-alert-message {
      display: none !important;
  }
`;